<template>
  <div class="container">
    <topHeader title="账单详情"></topHeader>

    <div v-if="item.type === 1" class="content">
      <div class="type">充值详情</div>
      <div class="time">
        <div class="label">充值时间</div>
        <div class="value">{{ item.payTime }}</div>
      </div>
      <div v-if="list.length > 0" class="record-list">
        <div class="record" :style="{ '--columns': item.rateAmount ? 5 : 4 }">
          <div class="head">
            <div class="head-title">订单号</div>
            <div class="head-title">充值金额</div>
            <div v-if="item.rateAmount" class="head-title">手续费</div>

            <div class="head-title">充值结果</div>
            <div class="head-title">充值途径</div>
          </div>
          <div class="body">
            <div v-for="item in list" :key="item.id" class="list">
              <div class="list-item">{{ item.orderNo }}</div>
              <div class="list-item">
                {{
                  currencyTransform(
                    Number(item.amount) + Number(item.rateAmount)
                  )
                }}
              </div>
              <div v-if="item.rateAmount" class="list-item">
                {{ currencyTransform(item.rateAmount) }}
              </div>
              <div class="list-item">
                {{
                  item.status === 1
                    ? '失败'
                    : item.status === 0
                    ? '成功'
                    : '未知'
                }}
              </div>
              <div class="list-item">
                {{
                  item.channel === 'ICBC' || item.channel === 'ABC'
                    ? '线上充值'
                    : item.channel === 'CASH'
                    ? '手动充值'
                    : item.channel === 'SMFACE'
                    ? '设备充值'
                    : '一'
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="content">
      <div class="type">退款详情</div>
      <div class="time">
        <div class="label">退款时间</div>
        <div class="value">{{ item.payTime }}</div>
      </div>
      <div v-if="list.length > 0" class="record-list">
        <div class="record" :style="{ '--columns': 3 }">
          <div class="head">
            <div class="head-title name">订单号</div>
            <div class="head-title">退款金额</div>
            <div class="head-title">退款结果</div>
            <!-- <div class="head-title">扣费状态</div> -->
          </div>
          <div class="body">
            <div v-for="item in list" :key="item.id" class="list">
              <div class="list-item name">{{ item.outtrxSerialNo }}</div>
              <div class="list-item">
                {{ currencyTransform(item.rejectAmt) }}
              </div>
              <div class="list-item">
                {{ item.returnMsg }}
              </div>
              <!-- <div
              class="list-item"
              :class="item.status === 2 ? 'error' : 'safe'"
            >
              {{ item.status === 2 ? '未缴费' : '已缴费' }}
            </div> -->
            </div>
            <div class="list">
              <div class="list-item name">合计</div>
              <div class="list-item">{{ currencyTransform(total) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <van-button
      v-if="isShowSwitch"
      class="btn"
      @click="generateAndPreviewImage"
    >
      查看凭证
    </van-button>
  </div>
</template>

<script>
import topHeader from '@/components/topHeader/index.vue';

import {
  getVoucherSwitchAPI,
  getVoucherAPI,
  getRefundVoucherAPI,
  getVoucherTemplateListAPI
} from '@/api/api.js';
import { refundDetail } from '@/api/refund/index';
import { currencyTransform } from '@/utils/util';
import html2canvas from 'html2canvas';
import { ImagePreview } from 'vant';
export default {
  name: '',
  components: { topHeader },
  data() {
    return {
      list: [],
      item: {},
      total: 0,
      isShowSwitch: false,
      rechargeVoucher: {
        title: '食堂收款收据',
        name: '',
        content: '充值',
        patType: '转账',
        type: 'person'
      },
      refundVoucher: {
        title: '食堂退款收据',
        name: '',
        content: '退款',
        patType: '转账',
        remark: '',
        type: 'person'
      }
    };
  },
  async created() {
    this.item = JSON.parse(this.$route.query.item);
    if (this.item.type === 1) {
      this.list.push(this.item);
    } else {
      if (this.item.versionType !== 1) {
        this.item.outtrxSerialNo = this.item.orderNo;
        this.item.rejectAmt = -this.item.amount;
        this.item.returnMsg =
          this.item.refundStatus === 4
            ? '退款成功'
            : this.item.refundStatus === 5
            ? '退款失败'
            : '退款中';
        this.list.push(this.item);
      } else {
        const res = await refundDetail({ refundVerifyId: this.item.id });
        if (res.code === 0) {
          this.list = res.data;
        }
      }
    }
    this.total = this.list.reduce((total, item) => {
      return total + Number(item.rejectAmt);
    }, 0);
    this.total = parseFloat(this.total).toFixed(2);
    await this.getVoucherSwitch();
    if (this.isShowSwitch) {
      await this.getTemplateList();
    }
  },
  mounted() {},
  methods: {
    async getVoucherSwitch() {
      const res = await getVoucherSwitchAPI();
      if (res.data === 1) {
        this.isShowSwitch = true;
      } else {
        this.isShowSwitch = false;
      }
    },
    toBack() {
      this.$router.go(-1);
    },
    currencyTransform,
    async getTemplateList() {
      try {
        const res = await getVoucherTemplateListAPI({
          organizationId: this.$store.getters.organizationId
        });

        const item = res.data.find((item) => {
          if (this.item.type === 1) {
            return item.name === 'recharge';
          } else {
            return item.name === 'refund';
          }
        });
        if (item) {
          console.log(JSON.parse(item.template));

          item.name === 'recharge'
            ? (this.rechargeVoucher = {
                ...this.rechargeVoucher,
                ...JSON.parse(item.template)
              })
            : (this.refundVoucher = {
                ...this.refundVoucher,
                ...JSON.parse(item.template)
              });
        }

        console.log(this.rechargeVoucher, 'this.refundVoucher');
      } catch (err) {
        console.log(err);
      }
    },

    async generateAndPreviewImage() {
      try {
        // 获取凭证数据
        if (this.item.type === 1) {
          const res = await getVoucherAPI({
            id: this.item.id,
            payTime: this.item.payTime,
            orderNo: this.item.orderNo,
            payMoney: this.item.amount
          });
          this.rechargeVoucher = { ...this.rechargeVoucher, ...res.data };
        } else {
          const res = await getRefundVoucherAPI({
            id: this.item.id,
            payTime: this.item.payTime,
            refundMoney: this.item.amount
          });
          this.refundVoucher = { ...this.refundVoucher, ...res.data };
        }

        // 创建临时容器（尺寸放大以容纳旋转后的内容）
        const tempDiv = document.createElement('div');
        tempDiv.style.cssText = `
          position: absolute;
          left: -9999px;
          width: 800px;  // 足够大的容器
          height: 600px;
          overflow: visible;
          padding: 20px;
          background: #fff;
        `;

        // 创建旋转容器
        const rotatedContainer = document.createElement('div');
        rotatedContainer.style.cssText = `
          width: 500px;
          transform: rotate(90deg);
          transform-origin: left top;
          position: relative;
          left: 500px;
          font-family: 'SimSun';
          padding:35px
        `;
        rotatedContainer.innerHTML = this.generateVoucherContent(
          this.item.type === 1 ? this.rechargeVoucher : this.refundVoucher
        );
        console.log(' this.rechargeVoucher', this.rechargeVoucher);

        tempDiv.appendChild(rotatedContainer);
        document.body.appendChild(tempDiv);

        // 等待渲染
        await new Promise((resolve) => setTimeout(resolve, 50));

        // 计算旋转后的实际尺寸
        const captureWidth = rotatedContainer.offsetHeight; // 旋转后宽高互换
        const captureHeight = 555;

        // 生成canvas
        const canvas = await html2canvas(rotatedContainer, {
          scale: 4,
          width: captureWidth,
          height: captureHeight,
          logging: false,
          useCORS: true,
          backgroundColor: '#ffffff',
          scrollX: 0,
          scrollY: 0
        });

        // 预览图片
        ImagePreview({
          images: [canvas.toDataURL('image/png')],
          closeable: true
        });
      } catch (error) {
        console.error('生成凭证失败:', error);
        this.$toast('生成凭证失败');
      } finally {
        const tempDiv = document.querySelector('div[style*="left: -9999px"]');
        if (tempDiv) document.body.removeChild(tempDiv);
      }
    },

    generateVoucherContent(data) {
      // 根据当前数据生成凭证HTML
      const isRecharge = this.item.type === 1;
      const title = isRecharge ? '充值凭证' : '退款凭证';
      const timeLabel = isRecharge ? '充值时间' : '退款时间';

      return `
      <!-- 标题 -->
      <div style="width: 100%; color: #303233; font-size: 18px; font-weight: 700; text-align: center; letter-spacing: 11.7px; margin-bottom: 15.5px;">
      ${data.title}
      </div>

      <!-- 日期和编号 -->
      <table style="width: 100%; margin-bottom: 12.2px; border-collapse: collapse;">
        <tr>
          <td style="width: 70%; color: #303233; font-size: 11px; font-weight: 400; padding: 0; white-space: nowrap;text-align:left">
            开票日期:${data.year} 年 ${data.month}月 ${data.day}日
          </td>
          <td style="width: 30%; text-align: right; padding: 0;">
            <span style="color: #303233; font-size: 15.5px; font-weight: 400;">NO.</span>
            <span style="color: #bc2121; font-size: 15.5px; font-weight: 400;">${data.No}</span>
          </td>
        </tr>
      </table>

      <!-- 主表格 - 使用固定布局确保列宽一致 -->
      <table style="width: 100%; border-left: 1px solid #030303; border-top: 1px solid #030303; border-collapse: collapse; table-layout: fixed;">
        <!-- 第一行 -->
        <tr>
          <td style="width: 166.5px; padding: 15.5px 0; border-right: 1px solid #030303; border-bottom: 1px solid #030303; font-weight: 700; text-align: center; white-space: nowrap;">
            缴费单位或个人
          </td>
          <td
          colspan="3"
          style="padding: 15.5px 0; border-right: 1px solid #030303; border-bottom: 1px solid #030303; text-align: center; font-weight: 400; overflow: hidden;">
          ${data.unit}
          </td>
        </tr>

        <!-- 第二行 -->
        <tr>
          <td style="width: 166.5px; padding: 15.5px 0; border-right: 1px solid #030303; border-bottom: 1px solid #030303; font-weight: 700; text-align: center; white-space: nowrap;">
            款项内容
          </td>
          <td style="padding: 15.5px 0; border-right: 1px solid #030303; border-bottom: 1px solid #030303; text-align: center; font-weight: 400; overflow: hidden;">
            ${data.content}
          </td>
          <td style="width: 166.5px; padding: 15.5px 0; border-right: 1px solid #030303; border-bottom: 1px solid #030303; font-weight: 700; text-align: center; white-space: nowrap;">
            收款方式
          </td>
          <td style="padding: 15.5px 0; border-right: 1px solid #030303; border-bottom: 1px solid #030303; text-align: center; font-weight: 400; overflow: hidden;">
            ${data.patType}
          </td>
        </tr>

        <!-- 第三行 -->
        <tr>
          <td style="width: 166.5px; padding: 15.5px 0; border-right: 1px solid #030303; border-bottom: 1px solid #030303; font-weight: 700; text-align: center; white-space: nowrap;">
            金额
          </td>
          <td colspan="3" style="padding: 0; border-right: 1px solid #030303; border-bottom: 1px solid #030303;">
            <table style="width: 100%; border-collapse: collapse; table-layout: fixed;">
              <tr>
                <td style="padding: 15.5px 0; text-align: center; border-right: 1px solid #030303; font-weight: 400; overflow: hidden;">
                  ${data.moneyCN}
                </td>
                <td style="width: 166.5px; padding: 15.5px 0; text-align: center; font-weight: 400;">
                ${data.amount}
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <!-- 第四行 -->
        <tr>
          <td style="width: 166.5px; padding: 15.5px 0; border-right: 1px solid #030303; border-bottom: 1px solid #030303; font-weight: 700; text-align: center; white-space: nowrap;">
            备注
          </td>
          <td colspan="3" style="padding: 15.5px 0; border-right: 1px solid #030303; border-bottom: 1px solid #030303; text-align: center; font-weight: 400; overflow: hidden;">
          ${data.remark}
          </td>
        </tr>
      </table>

      <!-- 底部信息 -->
      <table style="width: 100%; margin-top: 8.9px; font-size: 11px; font-weight: 400; border-collapse: collapse;">
        <tr>
          <td style="width: 50%; padding: 8.9px; white-space: nowrap;text-align:left">
            收款单位盖章:
          </td>
          <td style="width: 50%; text-align: left; padding: 8.9px; white-space: nowrap;">
            开票人: ${data.name}
          </td>
        </tr>
      </table>
    `;
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding-bottom: 10px;
  .content {
    background-color: #fff;
    border-radius: 10px;
    box-sizing: border-box;
    margin: 10px 16px 0 16px;
    height: 552px;
    overflow: hidden;
    overflow-y: scroll;
    padding: 36px 12px 0 12px;
    .type {
      color: #333333;
      font-size: 18px;
      font-weight: 500;
      font-family: '苹方';
      text-align: center;
      margin-bottom: 40px;
    }
    .time {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      .label {
        color: #333333;
        font-size: 16px;
        font-weight: 400;
        font-family: '苹方';
      }
      .value {
        color: #666666;
        font-size: 16px;
        font-weight: 400;
        font-family: '苹方';
      }
    }
    .record-list {
      margin-top: 10px;
      width: 100%;
      box-sizing: border-box;
      .record {
        background-color: #f7f7f7;
        --columns: 4;

        // 使用grid布局使head和list垂直对齐
        .head,
        .body .list {
          display: grid;
          grid-template-columns: repeat(
            var(--columns),
            1fr
          ); // 根据列数进行分配
          /* gap: 10px; */
          align-items: center; // 垂直居中对齐
          color: #333333;
          font-size: 12px;
        }
        .name {
          width: 178px;
        }
        .head {
          font-weight: 500;
          position: relative;
          .head-title {
            box-sizing: border-box;
            /* 居中 */
            display: flex;
            justify-content: center;
            color: #333333;
            font-size: 14px;
            padding: 10px 0; /* 右边框 */
            border-right: 1px solid #e5e5e5;
            /* 每第三个没有有边框 */
          }
        }

        .head::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 1px;
          transform: scaleY(0.5);
          background-color: #e5e5e5;
        }

        .body {
          .list {
            font-weight: 400;
            .list-item {
              box-sizing: border-box;
              padding: 10px 0;
              height: 100%;
              /* 居中 */
              display: flex;
              justify-content: center;
              /* 允许换行 */
              flex-wrap: wrap;
              word-break: break-word; // 处理换行

              /* 右边框 */
              border-right: 1px solid #e5e5e5;
              /* 每第三个没有有边框 */
            }
          }
        }
        // 针对日期列不换行
        /* .head-title:nth-child(1),
      .list-item:nth-child(1) {
        white-space: nowrap; // 防止换行
      } */
        .head-title:nth-child(4),
        .list-item:nth-child(4) {
          /* 换行 */
          word-break: break-all;

          word-wrap: break-word;
          text-align: center;
        }
      }
    }
  }
  .btn {
    width: 343px;
    height: 44px;
    border-radius: 4px;
    opacity: 1;
    background: #fa5050;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 18px;
    font-weight: 500;
    margin-top: 20px;
  }
}
</style>
